import { inject, Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { firstValueFrom } from "rxjs";

import { EstablishmentThemeSchema } from "@shared/schemas/establishment-theme.schema";
import { Theme } from "@shared/types/theme/theme";
import { environment } from "@environments/environment";

@Injectable({
  providedIn: "root",
})
export class ThemeLoaderService {
  private readonly http = inject(HttpClient);

  async loadTheme(domain: string): Promise<Theme> {
    const response = await firstValueFrom(
      this.http.get(`${environment.apiUrl}/establishment/theme/${domain}`),
    );

    const data = EstablishmentThemeSchema.parse(response);

    return {
      name: data.FullName,
      assets: {
        logo: data.LogoUrl,
        favicon: data.FaviconUrl,
        badges: data.Badges.map((badge, index) => ({
          src: badge.ImageUrl,
          url: badge.Url,
          name: `Badge ${index + 1}`,
        })),
      },
      colors: {
        primary: data.Color,
      },
    };
  }
}
